import isEmpty from 'lodash/isEmpty'
import take from 'lodash/take'
import map from 'lodash/map'
import some from 'lodash/some'
import flatten from 'lodash/flatten'

import qs from 'qs'
import Ncs from 'ncs';

function sortFilterByLabel(option) {
  return option.value ? option.label : '' // Null options should be at the beginning
}

const collocationsConfig = {
  elements: {
    setup: (state, dispatch, config) => {
      // Exclude:
      // Preposición (SP)
      // Conjunción (C)
      // Determinante (D)
      // Numeral (Z)
      // Pronombre (P)
      // Signo de puntuación (F)
      let collocationElement
      if (state.elements.type === 'tokens') {
        collocationElement = {token: {value: '*'}, tag: {value: '!SP!C*!D*!Z*!P*!F*', tagSelectorUsed: 'pattern'}}
      } else {
        collocationElement = {unit: {value: '*'}}
      }
      const elements = {left: [collocationElement], right: [config.elements.emptyElement()]}
      dispatch('elements/setElements', elements, {root: true})
      dispatch('elements/setDistance', {type: 'lteq', number: 1}, {root: true})
    },
    teardown: (state, dispatch, config) => {
      dispatch('elements/setElements', {left: [config.elements.emptyElement()], right: []}, {root: true})
      dispatch('elements/setDistance', {type: null, number: 1}, {root: true})
    }
  }
}

export default {
  elements: {
    types: ['units', 'tokens']
  },
  tags: {
    categories: gon.tag_categories,
    matrix: gon.tag_matrix,
    hideLevels: ['noun_class', 'noun_subclass', 'noun_grade'],
    sortBy(option) {
      return option.tag !== '0' ? option.label : null // 'No aplicable' tag options should be at the end.
    }
  },
  filters: {
    values: gon.values,
    dependencyValues: gon.dependencyValues,
    sortBy: {
      'ncs_documents.text_genre': sortFilterByLabel,
      'ncs_documents.text_subgenre': sortFilterByLabel
    }
  },
  result: {
    defaultType: 'kwic',
    error: {
      contactLink: './contacto',
      contactEmail: 'support@nlpgo.com'
    },
    types: ['frequency', 'full_frequency', 'kwic', 'matching_expressions', 'collocations'],
    kwic: {
      order: {
        orders: [
          ...Ncs.utils.defaultOrder(5),
          {name: 'year', criteria: [{field: 'ncs_documents.year', asc: true}]},
          {name: 'text_genre', criteria: [{field: 'ncs_documents.text_genre', asc: true}]},
          {name: 'text_subgenre', criteria: [{field: 'ncs_documents.text_subgenre', asc: true}]},
          {name: 'specialization', criteria: [{field: 'ncs_documents.specialization', asc: true}]}
        ]
      }
    },
    full_frequency: {
      groups: {
        'ncs_documents.language': {sortBy: v => ['fr', 'en', 'es'].indexOf(v) },
        'ncs_documents.specialization': {sortBy: v => ['Especializado', 'Semiespecializado', 'Divulgativo'].indexOf(v) },
      },
    },
    context: {
      tokens: {sourceText: true}
    },
    collocations: collocationsConfig
  },
  queryLinks: {
    enabled: true,
    stringifyQuery(q, store) {
      if (store.getters['api/resultType'] === 'kwic') {
        const language = q.filters['ncs_documents.language']
        const units = flatten(map(q.elements.left, 'unit.value'))
        const object = {l: language, s: units.join(' ')}
        return qs.stringify(object, {arrayFormat: 'repeat', skipNulls: true, encode: false})
      } else {
        return ''
      }
    },
    parseQuery(s, store) {
      const parsed = qs.parse(s, {arrayFormat: 'repeat', decoder: Ncs.utils.decoder})
      const words = parsed.s ? take(parsed.s.split(' '), 5) : []
      if (some(words, w => !isEmpty(w))) {
        store.commit('api/changeResultType', 'kwic')
        store.dispatch('elements/setElements', {left: map(words, u => ({unit: {value: u}}))})
        store.commit('filters/setFilter', {'ncs_documents.language': parsed.l})
        store.dispatch('api/execute')
      }
    }
  }
}
